import { useState, useEffect } from "react";
import PermissionGate from "../layout/PermissionGate";
import RegenerateMerchantAPIKey from "./RegenerateMerchantAPIKey";

const MerchantAPIKey = ({ id }) => {
  const [key, setKey] = useState("");
  const [regenerate, setRegenerate] = useState(false);
  const [hidden, setHidden] = useState(true);
  const [copied, setCopied] = useState(false);
  const token = localStorage.getItem("token");

  const fetchAPIKey = async () => {
    axios
      .get(
        process.env.REACT_APP_API_ENDPOINT +
          `get-merchant-api-key?merchantId=${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      .then((res) => {
        if (res.data.code === 1) {
          setKey(res.data.data);
        }
      })
      .catch(console.error);
  };
  const regenerateAPIkey = async () => {
    axios
      .patch(
        process.env.REACT_APP_API_ENDPOINT +
          `regenerate-merchant-api-key?merchantId=${id}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      .then((res) => {
        if (res.data.code === 1) {
          fetchAPIKey();
        }
      })
      .catch(console.error);
  };

  useEffect(() => {
    fetchAPIKey();
  }, [id]);
  return (
    <>
      <div className="row g-5 g-lg-10 mt-4">
        {/*begin::Col*/}
        <div className="col p-0 mb-xl-10">
          <div className="d-flex justify-content-between align-items-center text-dark fw-bold m-0 fs-3 mb-5">
            <h1 className="d-flex text-dark fw-bold m-0 fs-3 mb-5">
              Merchant API Key
            </h1>
          </div>
          {/*begin::Tables Widget*/}
          <PermissionGate required={`view_merchant_api_keys`}>
            <div className="card p-5">
              <div className="text-center h4 fw-bolder p-10 border rounded">
                {key && hidden === false ? key : "*".repeat(74)}
              </div>
              {/*begin::Body*/}
              <div className="card-body">
                <div className="d-flex justify-content-center gap-2">
                  <PermissionGate
                    required={`view_merchant_api_keys`}
                    fallback={<></>}
                  >
                    <button
                      onClick={() => {
                        setHidden((prev) => !prev);
                      }}
                      className="btn btn-success"
                    >
                      <i
                        className={`bi-duotone ms-1 mb-1 d-none d-md-inline bi-${hidden ? "eye" : "eye-slash"}`}
                      ></i>
                      {hidden ? "Show" : "Hide"}
                    </button>
                  </PermissionGate>
                  <PermissionGate
                    required={`regenerate_merchant_api_keys`}
                    fallback={<></>}
                  >
                    <button
                      onClick={() => {
                        setRegenerate((prev) => !prev);
                      }}
                      className="btn btn-danger"
                    >
                      <i
                        className={`bi-duotone ms-1 bi-arrow-repeat mb-1 d-none d-md-inline`}
                      ></i>
                      Regenerate
                    </button>
                  </PermissionGate>
                  <PermissionGate
                    required={`view_merchant_api_keys`}
                    fallback={<></>}
                  >
                    <button
                      onClick={async () => {
                        await navigator.clipboard.writeText(key ?? "");
                        setCopied(true);
                        setTimeout(() => setCopied(false), 2000);
                      }}
                      className="btn btn-success"
                    >
                      <i
                        className={`bi-duotone ms-1 mb-1 d-none d-md-inline bi-${
                          copied === false ? "copy" : "clipboard-check-fill"
                        }`}
                      ></i>

                      {copied ? "Copied" : "Copy"}
                    </button>
                  </PermissionGate>
                </div>
              </div>
            </div>
          </PermissionGate>
          {/*end::Tables Widget*/}
        </div>
        {/*end::Col*/}
      </div>
      {regenerate && (
        <RegenerateMerchantAPIKey
          regenerate={regenerate}
          setRegenerate={setRegenerate}
          regenerateAPIkey={regenerateAPIkey}
        />
      )}
    </>
  );
};

export default MerchantAPIKey;
